import { Component } from "@angular/core";
@Component({
    selector: 'kendo-Loader',
    template: `
    <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
    `,
    styleUrls:['./KendoLoader.scss']
})
export class MykendoLoader {

}
